import { type PostContentObjectDetail, type UploadedFile, createPostContentObjectDetail } from 'models';
import { useMutation } from 'query';
import { handleAxiosError } from 'ui';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { createPost } from '../../services';
import { useContentObjectCache } from '../cache';

type CreatePostData = {
  attachments?: UploadedFile[];
  communityId?: string;
  groupId?: string;
  htmlContent: string;
  pinned?: boolean;
  textContent: string;
};

const defaultErrorHandler = (error: ApiClientResponseError<ResponseErrorDataObject>) => {
  handleAxiosError(error, 'Something went wrong. Please, try again.');
};

/**
 * @deprecated Introduced as part of the #87353 feed refactor to manually patch the React Query cache
 * after each mutation. This ad-hoc cache-patching approach needs a better long-term solution.
 */
export const useCreatePostMutation = () => {
  const cache = useContentObjectCache();

  return useMutation<PostContentObjectDetail, CreatePostData>({
    defaultMutateOnError: defaultErrorHandler,
    async mutationFn({ attachments, communityId, groupId, htmlContent, pinned, textContent }) {
      const response = await createPost({
        body: {
          post: {
            attachments: attachments?.map((attachment) => ({
              id: attachment.id,
            })),
            community_id: communityId,
            group_id: groupId,
            html_content: htmlContent,
            parent_id: null,
            pinned,
            post: {
              html_content: htmlContent,
              text_content: textContent,
            },
            text_content: textContent,
            type: 'post',
          },
        },
      });

      return createPostContentObjectDetail(response.data);
    },
    onSuccess(data) {
      cache.create(data);
    },
  });
};
